module.exports = __webpack_public_path__ + "static/media/empty_state_blocked.a8456364.svg";